import type { Theme } from '@mui/material/styles'

import MuiButton from './MuiButton'
import MuiButtonBase from './MuiButtonBase'
import MuiCheckbox from './MuiCheckbox'
import MuiCircularProgress from './MuiCircularProgress'
import MuiCssBaseline from './MuiCssBaseline'
import MuiDialog from './MuiDialog'
import MuiContainer from './MuiContainer'
import MuiFilledInput from './MuiFilledInput'
import MuiFormControlLabel from './MuiFormControlLabel'
import MuiFormHelperText from './MuiFormHelperText'
import MuiIconButton from './MuiIconButton'
import MuiLink from './MuiLink'
import MuiListItemText from './MuiListItemText'
import MuiMenu from './MuiMenu'
import MuiMenuItem from './MuiMenuItem'
import MuiPagination from './MuiPagination'
import MuiPaginationItem from './MuiPaginationItem'
import MuiPaper from './MuiPaper'
import MuiTabs from './MuiTabs'
import MuiTab from './MuiTab'
import MuiTableCell from './MuiTableCell'
import MuiTableContainer from './MuiTableContainer'
import MuiTablePagination from './MuiTablePagination'
import MuiInputAdornment from './MuiInputAdornment'
import MuiInputBase from './MuiInputBase'
import MuiInputLabel from './MuiInputLabel'
import MuiLoadingButton from './MuiLoadingButton'
import MuiTextField from './MuiTextField'
import MuiTypography from './MuiTypography'

export const getComponentsFromBaseTheme = (theme: Theme) => ({
  components: {
    MuiButton: MuiButton(theme),
    MuiButtonBase: MuiButtonBase(),
    MuiCheckbox: MuiCheckbox(theme),
    MuiCircularProgress: MuiCircularProgress(),
    MuiCssBaseline: MuiCssBaseline(),
    MuiDialog: MuiDialog(),
    MuiContainer: MuiContainer(theme),
    MuiFilledInput: MuiFilledInput(theme),
    MuiFormControlLabel: MuiFormControlLabel(theme),
    MuiFormHelperText: MuiFormHelperText(theme),
    MuiIconButton: MuiIconButton(theme),
    MuiLink: MuiLink(theme),
    MuiListItemText: MuiListItemText(theme),
    MuiMenu: MuiMenu(theme),
    MuiMenuItem: MuiMenuItem(theme),
    MuiPagination: MuiPagination(theme),
    MuiPaginationItem: MuiPaginationItem(theme),
    MuiPaper: MuiPaper(theme),
    MuiTabs: MuiTabs(theme),
    MuiTab: MuiTab(theme),
    MuiTableCell: MuiTableCell(theme),
    MuiTableContainer: MuiTableContainer(),
    MuiTablePagination: MuiTablePagination(theme),
    MuiInputAdornment: MuiInputAdornment(theme),
    MuiInputBase: MuiInputBase(theme),
    MuiInputLabel: MuiInputLabel(theme),
    MuiLoadingButton: MuiLoadingButton(theme),
    MuiTextField: MuiTextField(),
    MuiTypography: MuiTypography(),
  },
})
